import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const LoadableCreditError = loadable(() => import('./CreditError'), {
  fallback: <LoadingScreen />,
});

export default LoadableCreditError;
